import { render, staticRenderFns } from "./Dialog_UpdateMainSchoolScore.vue?vue&type=template&id=0e8dce5b&scoped=true&"
import script from "./Dialog_UpdateMainSchoolScore.vue?vue&type=script&lang=js&"
export * from "./Dialog_UpdateMainSchoolScore.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_UpdateMainSchoolScore.vue?vue&type=style&index=0&id=0e8dce5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8dce5b",
  null
  
)

export default component.exports